/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { LegalEntityResultResource } from './';
import {
    LegalEntityResultResourceFromJSON,
    LegalEntityResultResourceFromJSONTyped,
    LegalEntityResultResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface LegalEntitySearchResultResource
 */
export interface LegalEntitySearchResultResource {
    /**
     * 
     * @type {Array<LegalEntityResultResource>}
     * @memberof LegalEntitySearchResultResource
     */
    items: Array<LegalEntityResultResource>;
    /**
     * 
     * @type {number}
     * @memberof LegalEntitySearchResultResource
     */
    totalCount: number;
    /**
     * 
     * @type {number}
     * @memberof LegalEntitySearchResultResource
     */
    totalPages: number;
    /**
     * 
     * @type {boolean}
     * @memberof LegalEntitySearchResultResource
     */
    hasNext: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LegalEntitySearchResultResource
     */
    hasPrevious: boolean;
    /**
     * 
     * @type {number}
     * @memberof LegalEntitySearchResultResource
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof LegalEntitySearchResultResource
     */
    pageSize: number;
}

/**
 * Check if a given object implements the LegalEntitySearchResultResource interface.
 */
export function instanceOfLegalEntitySearchResultResource(value: object): value is LegalEntitySearchResultResource {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined) return false;
    if (!('hasNext' in value) || value['hasNext'] === undefined) return false;
    if (!('hasPrevious' in value) || value['hasPrevious'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('pageSize' in value) || value['pageSize'] === undefined) return false;
    return true;
}

export function LegalEntitySearchResultResourceFromJSON(json: any): LegalEntitySearchResultResource {
    return LegalEntitySearchResultResourceFromJSONTyped(json, false);
}

export function LegalEntitySearchResultResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalEntitySearchResultResource {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(LegalEntityResultResourceFromJSON)),
        'totalCount': json['totalCount'],
        'totalPages': json['totalPages'],
        'hasNext': json['hasNext'],
        'hasPrevious': json['hasPrevious'],
        'page': json['page'],
        'pageSize': json['pageSize'],
    };
}

export function LegalEntitySearchResultResourceToJSON(value?: LegalEntitySearchResultResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'items': ((value['items'] as Array<any>).map((v) => LegalEntityResultResourceToJSON(v))),
        'totalCount': value['totalCount'],
        'totalPages': value['totalPages'],
        'hasNext': value['hasNext'],
        'hasPrevious': value['hasPrevious'],
        'page': value['page'],
        'pageSize': value['pageSize'],
    };
}

